import { render, staticRenderFns } from "./PresentacionesModal.vue?vue&type=template&id=3e4036e6&"
import script from "./PresentacionesModal.vue?vue&type=script&lang=js&"
export * from "./PresentacionesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports